module.exports = __webpack_public_path__ + "img/smile.d0af03da.png";